var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menu-footer" }, [
    _c("div", { staticClass: "menu-footer__controls" }, [
      _c(
        "div",
        {
          staticClass: "menu-footer__pill",
          class: { active: _vm.isLimitsPanelOpen },
          on: {
            click: function ($event) {
              _vm.isLimitsPanelOpen = !_vm.isLimitsPanelOpen
            },
          },
        },
        [
          _c("span", { staticClass: "menu-footer__pill-label" }, [
            _vm._v(_vm._s(_vm.$t("Max"))),
          ]),
          _c("span", { staticClass: "menu-footer__pill-divider" }, [
            _vm._v("|"),
          ]),
          _c("span", { staticClass: "menu-footer__pill-value" }, [
            _vm._v(
              _vm._s(_vm.formatAmountWithKM(_vm.mainLimitAmountPerFight, 0))
            ),
          ]),
          _c("span", {
            staticClass: "menu-footer__chevron",
            class: { up: _vm.isLimitsPanelOpen },
          }),
          _c("div", { staticClass: "drop-down" }, [
            _c("div", { staticClass: "drop-down-item" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/svg/chart-icons/banker.svg"),
                  alt: "Banker",
                },
              }),
              _c("img", {
                attrs: {
                  src: require("@/assets/svg/chart-icons/player.svg"),
                  alt: "Player",
                },
              }),
              _c("span", { staticClass: "limit-text" }, [
                _vm._v(
                  _vm._s(_vm.formatAmountWithKM(_vm.mainLimitAmountPerFight, 0))
                ),
              ]),
            ]),
            _c("div", { staticClass: "drop-down-item" }, [
              _c("img", {
                staticClass: "draw-icon",
                attrs: {
                  src: require("@/assets/svg/chart-icons/draw.svg"),
                  alt: "Draw",
                },
              }),
              _c("span", { staticClass: "limit-text" }, [
                _vm._v(
                  _vm._s(_vm.formatAmountWithKM(_vm.drawLimitAmountPerFight, 0))
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "menu-footer__pill menu-footer__lang" },
        [_c("LanguageDropdown", { attrs: { open: "up" } })],
        1
      ),
      _c("div", { staticClass: "menu-footer__float-group" }, [
        _c(
          "button",
          {
            staticClass: "menu-footer__icon-btn",
            class: { active: _vm.isFloatingVideo },
            attrs: {
              type: "button",
              title: _vm.$t("float video"),
              "aria-pressed": String(_vm.isFloatingVideo),
            },
            on: {
              click: function ($event) {
                return _vm.updateFloatVideo(true)
              },
            },
          },
          [
            _c("span", {
              staticClass:
                "menu-footer__float-icon menu-footer__float-icon--on",
            }),
          ]
        ),
        _c("span", {
          staticClass: "menu-footer__float-divider",
          attrs: { "aria-hidden": "true" },
        }),
        _c(
          "button",
          {
            staticClass: "menu-footer__icon-btn",
            class: { active: !_vm.isFloatingVideo },
            attrs: {
              type: "button",
              title: _vm.$t("float video"),
              "aria-pressed": String(!_vm.isFloatingVideo),
            },
            on: {
              click: function ($event) {
                return _vm.updateFloatVideo(false)
              },
            },
          },
          [
            _c("span", {
              staticClass:
                "menu-footer__float-icon menu-footer__float-icon--off",
            }),
          ]
        ),
      ]),
      _c(
        "button",
        {
          staticClass: "menu-footer__close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("img", {
            attrs: { src: require("@/assets/images/close.webp"), alt: "" },
          }),
        ]
      ),
    ]),
    _c("div", { staticClass: "menu-footer__user-row" }, [
      _c("div", { staticClass: "menu-footer__balance" }, [
        _vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.userBalance)),
      ]),
      _c("div", { staticClass: "menu-footer__user" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/user.webp"), alt: "" },
        }),
        _c("span", [_vm._v(_vm._s(_vm.memberName))]),
      ]),
      _c("div", { staticClass: "menu-footer__logo-wrap" }, [_c("Logo")], 1),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }